export default {
    SET_JWT_TOKEN: "SET_JWT_TOKEN",
    SET_USER: "SET_USER",
    LOGOUT_USER: "LOGOUT_USER",
}
